import { render, staticRenderFns } from "./Ep3.vue?vue&type=template&id=65e4aaf6&scoped=true&"
import script from "./Ep3.vue?vue&type=script&lang=ts&"
export * from "./Ep3.vue?vue&type=script&lang=ts&"
import style0 from "./Ep3.vue?vue&type=style&index=0&id=65e4aaf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e4aaf6",
  null
  
)

export default component.exports